import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import RecipesRecipe from './Recipe';

const RecipeStep = ApplicationRecord.extend({
  attrs: {
    recipe: belongsTo({ type: RecipesRecipe, persist: false }),
    recipe_id: attr({ type: Number }),
    position: attr({ type: Number }),
    title: attr( { type: String }),
    description: attr(),
    duration_minutes: attr({ type: Number }),
    prep_time_minutes: attr({ type: Number }),
    recipe_portion_components: hasMany({
      type: 'recipes-recipe_portion_components',
    }),
  },
  static: {
    jsonapiType: 'recipes-recipe_steps',
  },
});

export default RecipeStep;
